var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MultipleAreaBase',{attrs:{"width":_vm.width,"title":_vm.title,"pageData":_vm.pageData,"tables":_vm.pageData,"isFooter":_vm.isFooter,"isExpansionPanelFooter":true},scopedSlots:_vm._u([{key:_vm.pageData[0].name,fn:function(ref){
var item = ref.item;
return [_vm._t(_vm.pageData[0].name,null,{"item":item})]}},{key:_vm.pageData[1].name,fn:function(ref){
var item = ref.item;
return [_vm._t(_vm.pageData[1].name,null,{"item":item})]}},{key:_vm.pageData[2].name,fn:function(ref){
var item = ref.item;
return [_vm._t(_vm.pageData[2].name,null,{"item":item})]}}],null,true),model:{value:(_vm.inputedValue),callback:function ($$v) {_vm.inputedValue=$$v},expression:"inputedValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }